export default __webpack_public_path__ + "static/media/red-packet.24ae17b3.png";